import { useState } from 'react';
import classNames from 'classnames';
import { t } from 'ttag';

import { Button } from '@ui/Button';
import FeedFilterTitle from '@components/FeedFilterTitle';

// styles
import s from './FeedSizeFilter.sss';

// types
type SizeOption = {
  secondarySizeName?: string | null;
  primarySizeName?: string | null;
  id: number | string
};

type FeedSizeFilterProps = {
  sizeGroupTitle?: string,
  options: SizeOption[];
  actives: number[];
  select(id: number): void;
};

export const FeedSizeFilter: React.FC<FeedSizeFilterProps> = ({
  sizeGroupTitle,
  options,
  actives,
  select,
}) => {
  const [isHide, setHide] = useState(false);
  const activeSizes = actives || [];

  if (!options.length) {
    return null;
  }

  return (
    <div className={s.root}>
      <div className={s.wrapper}>
        <FeedFilterTitle
          title={sizeGroupTitle || t`Розмір`}
          hide={isHide}
          onClick={() => setHide(!isHide)}
        />
        { !isHide && (
          <ul className={s.list}>
            {options.map((data) => (
              <li
                key={data.id}
                className={s.item}
              >
                <Button
                  className={classNames(s.button, {
                    [s.buttonStateActive]: activeSizes.includes(+data.id),
                  })}
                  theme='text'
                  onClick={() => select(+data.id)}
                >
                  <span className={s.primaryName}>
                    {data.primarySizeName}
                  </span>

                  {!!data.secondarySizeName && (
                    <span className={s.secondaryName}>
                      {data.secondarySizeName}
                    </span>
                  )}
                </Button>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default FeedSizeFilter;
